// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 237 ? "pages" : chunkId) + "." + {"237":"740a391f","372":"407fe128","668":"7d906c7e","739":"96563d81"}[chunkId] + ".js";
};